import { useCallback } from 'react';
/**
 * Hook that provides a function to clear focus from any active element on the page.
 * This is particularly useful on mobile web to prevent focus styling from showing
 * on buttons after they are clicked, such as the Map/List toggle buttons.
 */
export const useClearFocus = () => {
    const clearFocus = useCallback(() => {
        // Clear focus from any currently focused element
        if (document.activeElement &&
            document.activeElement instanceof HTMLElement) {
            document.activeElement.blur();
        }
        // Additional safety: ensure no element has focus by setting focus to body
        // and then removing focus from body as well
        if (document.body) {
            document.body.focus();
            document.body.blur();
        }
    }, []);
    return {
        clearFocus,
    };
};
